<template>
    <div class="attach">
        <Form :model="formData" ref="attachForm">
            <FormItem :labelWidth="60" label="附件类型">
                <Select v-model="formData.attachType">
                    <Option value="Other">Other</Option>
                    <Option value="ShippingLabel">ShippingLabel</Option>
                    <Option value="PackingList">PackingList</Option>
                    <Option value="BOL">BOL</Option>
                    <Option value="CartonLabel">CartonLabel</Option>
                    <Option value="PalletLabel">PalletLabel</Option>
                    <Option value="ItemLabel">ItemLabel</Option>
                </Select>
            </FormItem>
        </Form>
        <div class="margin-bottom-15">ShippingLabel、PackingList、BOL三种类型支持格式为：PNG、JPG、PDF；Other格式不限</div>
        <div>
            <compMutiUpload v-bind="getFileProps" @on-success="handleSuccess" @on-cancel="handleCancel"></compMutiUpload>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'id' ],
    data () {
        return {
            formData: {
                attachType: "Other"
            }
        }
    },
    computed: {
        getFileProps () {
            return {
                action: process.env.VUE_APP_APIURL_FBB + "/api/v2/Transit/attachmentUpload",
                name: "multipartFile",
                data: {
                    transitPlanOrderId: this.id,
                    attachType: this.formData.attachType
                },
                // accept: this.formData.attachType === 'Other' ? '' : 'image/*,application/pdf',
                formatter: (res) => {
                    return res.data;
                }
            }
        },
    },
    methods: {
        handleSuccess (data) {
            this.$emit('on-success', data);
        },
        handleCancel () {
            this.$emit('on-cancel');
        }
    }
}
</script>

<style>

</style>